export const RESERVE = 'reserve'
export const SELL = 'sell'
export const UNRESERVE = 'unreserve'

export default {
    RESERVE,
    SELL,
    UNRESERVE
}